import {
  PARTNER_NAME_BAD_STRUCTURE_REGEX,
  PARTNER_NAME_MAX_LENGTH,
  PARTNER_NAME_MIN_LENGTH,
  PARTNER_NAME_NO_NUMBERS_REGEX,
  PARTNER_NAME_VALID_CHARS_REGEX,
} from './const';

export type PartnerNameErrorCode =
  | 'required'
  | 'tooLong'
  | 'containsNumbers'
  | 'containsInvalidCharacters'
  | 'invalid';

export interface ValidatePartnerNameOptions {
  allowEmpty?: boolean;
}

/**
 * Applies partner name rules in order and returns the
 * first one that fails, or null when the name is acceptable
 */
export const validatePartnerName = (
  value: string,
  { allowEmpty = false }: ValidatePartnerNameOptions = {},
): PartnerNameErrorCode | null => {
  if (value.length > PARTNER_NAME_MAX_LENGTH) return 'tooLong';
  if (!allowEmpty && value.length < PARTNER_NAME_MIN_LENGTH) return 'required';

  // an empty optional name skips the content rules
  if (value === '') return null;

  if (PARTNER_NAME_NO_NUMBERS_REGEX.test(value)) return 'containsNumbers';
  if (!PARTNER_NAME_VALID_CHARS_REGEX.test(value)) return 'containsInvalidCharacters';
  if (PARTNER_NAME_BAD_STRUCTURE_REGEX.test(value)) return 'invalid';

  return null;
};
